export default (maybeValue, fallback) =>
  typeof maybeValue === 'undefined' || maybeValue === null ? fallback : maybeValue
